<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :reduceHeight='200'
      :expandRowKeys='mainTable.expandRowKeys'
      :showOperationsColumn='true' operationColumnWidth='240'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='已上材料查询' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showICMOEntryFeedDialogMD(scope)'><i class='wms wms-search1'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='上料' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showLoadingPower && (scope.data.row.Status === "2")'
            @click='showICMOEntryLoadingDialogMD(scope)'><i class='wms wms-item'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='补料' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showAddLoadingPower && (scope.data.row.Status === "3" || scope.data.row.Status === "4" || scope.data.row.Status === "5")'
            @click='showICMOEntryAddLoadingDialogMD(scope)'><i class='wms wms-purchasemanage'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤料' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showDownPower && (scope.data.row.Status === "3" || scope.data.row.Status === "4" || scope.data.row.Status === "5" || scope.data.row.Status === "6")'
            @click='showICMOEntryDownDialogMD(scope)'><i class='wms wms-logout'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='开工' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showStartPower && (scope.data.row.Status === "2" || scope.data.row.Status === "3")'
            @click='showICMOEntryStartDialogMD(scope)'><i class='wms wms-start'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='暂停' placement='top-start'>
          <el-button type='danger' circle style='padding: 4px;'
            v-if='showStopPower && (scope.data.row.Status === "4")'
            @click='showICMOEntryStopDialogMD(scope)'><i class='wms wms-stop'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='继续' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showContinuePower && (scope.data.row.Status === "5")'
            @click='showICMOEntryContinueDialogMD(scope)'><i class='wms wms-continue'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='完工' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            v-if='showEndPower && (scope.data.row.Status === "4")'
            @click='showICMOEntryEndDialogMD(scope)'><i class='sys sys-yes4'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤销开工' placement='top-start'>
          <el-button type='danger' circle style='padding: 4px;'
            v-if='showCancelStartPower && (scope.data.row.Status === "4")'
            @click='cancelICMOEntryStart(scope)'><i class='wms wms-start'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='撤销完工' placement='top-start'>
          <el-button type='danger' circle style='padding: 4px;'
            v-if='showCancelEndPower && (scope.data.row.Status === "6")'
            @click='cancelICMOEntryEnd(scope)'><i class='sys sys-yes4'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>记录号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>操作时间</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>操作账号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>操作类型</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>设备</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>职员</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>备注</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(icmoer, index) in scope.data.row.detailDt1'
            :key='icmoer.RecordID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'>
              <span :style='"color: blue;"'>{{index + 1}} </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.RecordID}} </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='"color: blue;"'>
                {{!icmoer.ReportTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoer.ReportTime), 'yyyy-MM-dd HH:mm:ss')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.ReportUserName}} </span>
            </div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span :style='"color: blue;"'>{{showExpandTransformSpecialString('ReportType', icmoer.ReportType)}} </span>
            </div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.ReportMachineName ? icmoer.ReportMachineName + '(' + icmoer.ReportMachineNumber + ')' : ''}} </span>
            </div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'>
              <span :style='"color: blue;"'>{{(icmoer.ReportEmployeeName ? icmoer.ReportEmployeeName : '') +
                (icmoer.ReportEmployeeName2 ? '|' + icmoer.ReportEmployeeName2 : '') +
                (icmoer.ReportEmployeeName3 ? '|' + icmoer.ReportEmployeeName3 : '') +
                (icmoer.ReportEmployeeName4 ? '|' + icmoer.ReportEmployeeName4 : '') +
                (icmoer.ReportEmployeeName5 ? '|' + icmoer.ReportEmployeeName5 : '') +
                (icmoer.ReportEmployeeName6 ? '|' + icmoer.ReportEmployeeName6 : '') }}
              </span>
            </div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.Remark}} </span>
            </div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='已上物料明细' :visible.sync='showICMOEntryFeedDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='icmoEntryFeeds' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag :title='"工单【" + icmoEntryLoadingInfo.DetailNo + "】上料"' top='10px'
      :visible.sync='showICMOEntryLoadingDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryLoadingInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          计划设备
        </div>
        <el-input v-model='icmoEntryLoadingInfo.PlanMachineNumber' size='mini' class='inputField-input'
          disabled style='width: 200px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          计划职员
        </div>
        <el-input v-model='icmoEntryLoadingInfo.PlanEmployeeName' size='mini' class='inputField-input'
          disabled style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='loadingScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          实际设备
        </div>
        <el-select v-model='icmoEntryLoadingInfo.MachineID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='machine in machines'
            :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          实际职员
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          实际职员2
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID2' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          实际职员3
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID3' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          实际职员4
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID4' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='margin-top: 120px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          实际职员5
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID5' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          实际职员6
        </div>
        <el-select v-model='icmoEntryLoadingInfo.EmployeeID6' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备 注
        </div>
        <el-input v-model='icmoEntryLoadingInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 160px;'>
        <el-tab-pane label='原料明细' name='feed'>
          <el-table :data='icmoEntryLoadingInfo.Feed' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :highlight-current-row='false'
            :cell-style='tableCellStyle' row-key='ItemID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='ItemNumber' label='物料代码' width='250'>
            </el-table-column>
            <el-table-column prop='ItemName' label='物料名称' width='300'>
            </el-table-column>
            <el-table-column prop='Qty' label='上料数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='UnitName' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='ItemModel' label='规格' width='300'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='qrCode'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :cell-style='tableCellStyle' row-key='GUID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='LoadingQty' label='上料数量' width='120'>
              <template #header>
                <span style='color: blue;'>上料数量</span>
              </template>
              <template #default='scope'>
                <input class='tableInput' v-model='scope.row.LoadingQty' @change='loadingScanQtyComputer()'
                  style='width: 100px;'/>
              </template>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='Status' label='状态' width='60'>
              <template #default='scope'>
                {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
              </template>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='loadingDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryLoading()' size='mini'>上料</el-button>
        <el-button @click='showICMOEntryLoadingDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :title='"工单【" + icmoEntryDownInfo.DetailNo + "】撤料"' top='10px'
      :visible.sync='showICMOEntryDownDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryDownInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='downScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备 注
        </div>
        <el-input v-model='icmoEntryDownInfo.Remark' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 80px;'>
        <el-tab-pane label='原料明细' name='feed'>
          <el-table :data='icmoEntryDownInfo.Feed' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :highlight-current-row='false'
            :cell-style='tableCellStyle' row-key='ItemID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='ItemNumber' label='物料代码' width='250'>
            </el-table-column>
            <el-table-column prop='ItemName' label='物料名称' width='300'>
            </el-table-column>
            <el-table-column prop='Qty' label='撤料数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='UnitName' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='ItemModel' label='规格' width='300'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='qrCode'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :cell-style='tableCellStyle' row-key='GUID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='DownQty' label='撤料数量' width='120'>
              <template #header>
                <span style='color: blue;'>撤料数量</span>
              </template>
              <template #default='scope'>
                <input class='tableInput' v-model='scope.row.DownQty' @change='downScanQtyComputer()'
                  style='width: 100px;'/>
              </template>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='Status' label='状态' width='60'>
              <template #default='scope'>
                {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
              </template>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='downDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryDown()' size='mini'>撤料</el-button>
        <el-button @click='showICMOEntryDownDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :title='"工单【" + icmoEntryAddLoadingInfo.DetailNo + "】补料"' top='10px'
      :visible.sync='showICMOEntryAddLoadingDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryAddLoadingInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='addLoadingScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备 注
        </div>
        <el-input v-model='icmoEntryAddLoadingInfo.Remark' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 80px;'>
        <el-tab-pane label='原料明细' name='feed'>
          <el-table :data='icmoEntryAddLoadingInfo.Feed' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :highlight-current-row='false'
            :cell-style='tableCellStyle' row-key='ItemID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='ItemNumber' label='物料代码' width='250'>
            </el-table-column>
            <el-table-column prop='ItemName' label='物料名称' width='300'>
            </el-table-column>
            <el-table-column prop='Qty' label='补料数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='UnitName' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='ItemModel' label='规格' width='300'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='qrCode'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            style='margin-top: 0px;'
            :cell-style='tableCellStyle' row-key='GUID'
            :header-cell-style='tableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='AddLoadingQty' label='补料数量' width='120'>
              <template #header>
                <span style='color: blue;'>补料数量</span>
              </template>
              <template #default='scope'>
                <input class='tableInput' v-model='scope.row.AddLoadingQty' @change='addLoadingScanQtyComputer()'
                  style='width: 100px;'/>
              </template>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='Status' label='状态' width='60'>
              <template #default='scope'>
                {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
              </template>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='addLoadingDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryAddLoading()' size='mini'>补料</el-button>
        <el-button @click='showICMOEntryAddLoadingDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

   <el-dialog v-dialogDrag :title='"工单【" + icmoEntryStartInfo.DetailNo + "】开工"' top='10px'
      :visible.sync='showICMOEntryStartDialog' width='320px'>
      <div style='margin-top: -30px; height: 35px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryStartInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          数量
        </div>
        <el-input v-model='icmoEntryStartInfo.Qty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          开工设备
        </div>
        <el-select v-model='icmoEntryStartInfo.MachineID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='machine in machines'
            :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          开工职员
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          开工职员2
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID2' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          开工职员3
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID3' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          开工职员4
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID4' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          开工职员5
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID5' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          开工职员6
        </div>
        <el-select v-model='icmoEntryStartInfo.EmployeeID6' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备注
        </div>
        <el-input v-model='icmoEntryStartInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryStart()' size='mini'>开工</el-button>
        <el-button @click='showICMOEntryStartDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :title='"工单【" + icmoEntryStopInfo.DetailNo + "】暂停"' top='10px'
      :visible.sync='showICMOEntryStopDialog' width='320px'>
      <div style='margin-top: -30px; height: 35px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryStopInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          数量
        </div>
        <el-input v-model='icmoEntryStopInfo.Qty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          暂停设备
        </div>
        <el-select v-model='icmoEntryStopInfo.MachineID' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='machine in machines'
            :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          暂停职员
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          暂停职员2
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID2' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          暂停职员3
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID3' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          暂停职员4
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID4' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          暂停职员5
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID5' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          暂停职员6
        </div>
        <el-select v-model='icmoEntryStopInfo.EmployeeID6' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备注
        </div>
        <el-input v-model='icmoEntryStopInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryStop()' size='mini'>暂停</el-button>
        <el-button @click='showICMOEntryStopDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

   <el-dialog v-dialogDrag :title='"工单【" + icmoEntryContinueInfo.DetailNo + "】继续"' top='10px'
      :visible.sync='showICMOEntryContinueDialog' width='320px'>
      <div style='margin-top: -30px; height: 35px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryContinueInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          数量
        </div>
        <el-input v-model='icmoEntryContinueInfo.Qty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          继续设备
        </div>
        <el-select v-model='icmoEntryContinueInfo.MachineID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='machine in machines'
            :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          继续职员
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          继续职员2
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID2' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          继续职员3
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID3' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          继续职员4
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID4' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          继续职员5
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID5' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          继续职员6
        </div>
        <el-select v-model='icmoEntryContinueInfo.EmployeeID6' placeholder='请选择'
          class='inputField-input'
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备注
        </div>
        <el-input v-model='icmoEntryContinueInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryContinue()' size='mini'>继续</el-button>
        <el-button @click='showICMOEntryContinueDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :title='"工单【" + icmoEntryEndInfo.DetailNo + "】完工"' top='10px'
      :visible.sync='showICMOEntryEndDialog' width='320px'>
      <div style='margin-top: -30px; height: 35px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          生产任务单号
        </div>
        <el-input v-model='icmoEntryEndInfo.BillNo' size='mini' class='inputField-input'
          disabled style='width: 170px;'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          数量
        </div>
        <el-input v-model='icmoEntryEndInfo.Qty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          完工设备
        </div>
        <el-select v-model='icmoEntryEndInfo.MachineID' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='machine in machines'
            :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          完工职员
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          完工职员2
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID2' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          完工职员3
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID3' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          完工职员4
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID4' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          完工职员5
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID5' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 70px; text-align: left'>
          完工职员6
        </div>
        <el-select v-model='icmoEntryEndInfo.EmployeeID6' placeholder='请选择'
          class='inputField-input' disabled
          style='width: 190px;' size='mini'>
          <el-option v-for='employee in employees'
            :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
          </el-option>
        </el-select>
      </div>
      <div style='height: 35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备注
        </div>
        <el-input v-model='icmoEntryEndInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='icmoEntryEnd()' size='mini'>完工</el-button>
        <el-button @click='showICMOEntryEndDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import dateTimeUtil from '@/utils/dateTimeUtil'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'ICMOEReport',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PM_ICMOEntry_2',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,
      reportTypes: [],
      employees: [],
      machines: [],
      qrcodeStatuss: [],

      scanQRCode: '',

      showICMOEntryFeedDialog: false,
      showICMOEntryFeedsRow: {},
      icmoEntryFeeds: [],

      showICMOEntryLoadingDialog: false,
      icmoEntryLoadingInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        PlanEmployeeID: '',
        PlanEmployeeName: '',
        PlanMachineID: '',
        PlanMachineNumber: '',
        PlanMachineName: '',
        Feed: [],
        EmployeeID: '',
        EmployeeID2: '',
        EmployeeID3: '',
        EmployeeID4: '',
        EmployeeID5: '',
        EmployeeID6: '',
        MachineID: '',
        Qty: 0,
        Remark: ''
      },
      scanQRCodes: [],
      activeTable: 'feed',

      showICMOEntryDownDialog: false,
      icmoEntryDownInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Feed: [],
        Qty: 0,
        Remark: ''
      },

      showICMOEntryAddLoadingDialog: false,
      icmoEntryAddLoadingInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Feed: [],
        Qty: 0,
        Remark: ''
      },

      showICMOEntryStartDialog: false,
      icmoEntryStartInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Qty: 0,
        EmployeeID: '',
        EmployeeID2: '',
        EmployeeID3: '',
        EmployeeID4: '',
        EmployeeID5: '',
        EmployeeID6: '',
        MachineID: '',
        Remark: ''
      },

      showICMOEntryStopDialog: false,
      icmoEntryStopInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Qty: 0,
        EmployeeID: '',
        EmployeeID2: '',
        EmployeeID3: '',
        EmployeeID4: '',
        EmployeeID5: '',
        EmployeeID6: '',
        MachineID: '',
        Remark: ''
      },

      showICMOEntryContinueDialog: false,
      icmoEntryContinueInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Qty: 0,
        EmployeeID: '',
        EmployeeID2: '',
        EmployeeID3: '',
        EmployeeID4: '',
        EmployeeID5: '',
        EmployeeID6: '',
        MachineID: '',
        Remark: ''
      },

      showICMOEntryEndDialog: false,
      icmoEntryEndInfo: {
        DetailNo: '',
        BillNo: '',
        InterID: '',
        Qty: 0,
        EmployeeID: '',
        EmployeeID2: '',
        EmployeeID3: '',
        EmployeeID4: '',
        EmployeeID5: '',
        EmployeeID6: '',
        MachineID: '',
        Remark: ''
      },

      showLoadingPower: false,
      showAddLoadingPower: false,
      showDownPower: false,
      showStartPower: false,
      showStopPower: false,
      showContinuePower: false,
      showEndPower: false,
      showCancelStartPower: false,
      showCancelEndPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const codes = that.codes
    that.reportTypes = code.getCode(codes, 'PM_ICMOEntryRecord_ReportType')
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const employeesPromise = table.getTableContent('BD_Employee', 10000, 1, '', " AND Deleted='0'")
    const machinesPromise = table.getTableContent('BD_Machine', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const employeesObj = await employeesPromise
    const machinesObj = await machinesPromise

    that.employees = employeesObj.tableContent
    that.machines = machinesObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '1') {
        return { 'background-color': 'orange' }
      } else if (data.row.Status === '2') { // 淡蓝色
        return { 'background-color': '#CAE1FF' }
      } else if (data.row.Status === '3') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '4') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '5') { // 红色
        return { 'background-color': '#FF6A6A' }
      } else if (data.row.Status === '6') { // 淡灰色
        return { 'background-color': '#AAAAAA' }
      } else if (data.row.Status === '8') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else if (data.row.Status === '9') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 显示操作明细特征字符串转换方法
    showExpandTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'ReportType') {
        return table.specialStringDisplayTransform(val, that.reportTypes)
      } else {
        return val
      }
    },

    // 获取生产入库扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 320 + 'px'
    },

    // 表格单元格样式
    tableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    tableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 上料弹出框显示方法
    showICMOEntryLoadingDialogMD: function (scope) {
      const that = this
      that.icmoEntryLoadingInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryLoadingInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryLoadingInfo.InterID = scope.data.row.InterID
      that.icmoEntryLoadingInfo.PlanEmployeeID = scope.data.row.PlanEmployeeID
      that.icmoEntryLoadingInfo.PlanEmployeeName = scope.data.row.PlanEmployeeName
      that.icmoEntryLoadingInfo.PlanMachineID = scope.data.row.PlanMachineID
      that.icmoEntryLoadingInfo.PlanMachineNumber = scope.data.row.PlanMachineNumber
      that.icmoEntryLoadingInfo.PlanMachineName = scope.data.row.PlanMachineName
      that.icmoEntryLoadingInfo.Feed = []
      that.icmoEntryLoadingInfo.EmployeeID = ''
      that.icmoEntryLoadingInfo.EmployeeID2 = ''
      that.icmoEntryLoadingInfo.EmployeeID3 = ''
      that.icmoEntryLoadingInfo.EmployeeID4 = ''
      that.icmoEntryLoadingInfo.EmployeeID5 = ''
      that.icmoEntryLoadingInfo.EmployeeID6 = ''
      that.icmoEntryLoadingInfo.MachineID = ''
      that.icmoEntryLoadingInfo.Remark = ''
      that.icmoEntryLoadingInfo.Qty = scope.data.row.Qty
      that.scanQRCodes = []
      that.showICMOEntryLoadingDialog = true
    },

    // 上料扫码方法
    loadingScanQRCodeEnterMD: async function () {
      const that = this
      if (!that.icmoEntryLoadingInfo.DetailNo) {
        that.$message.error('请先选择工单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        let passNum = 0
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            continue
          } else {
            passNum++
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            if (passNum === 0) {
              loadingInstance.close()
              that.$message.error('该标签号不是该生产任务单领出的，无法上料！')
              that.scanQRCode = ''
              return
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          that.scanQRCodes.push(Object.assign(qrCodeObj.tableContent[i], { LoadingQty: qrCodeObj.tableContent[i].Qty }))
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有可以上料的内箱标签！')
          return
        }
        that.loadingScanQtyComputer()
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 上料删除已扫描
    loadingDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      that.loadingScanQtyComputer()
    },

    // 上料已扫数量计算
    loadingScanQtyComputer: function () {
      const that = this
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].LoadingQty = parseFloat(that.scanQRCodes[i].LoadingQty)
        } catch {
          that.scanQRCodes[i].LoadingQty = 0
        }
        if (isNaN(that.scanQRCodes[i].LoadingQty)) {
          that.scanQRCodes[i].LoadingQty = 0
        }
        if (that.scanQRCodes[i].LoadingQty <= 0) {
          that.scanQRCodes[i].LoadingQty = 0
        }
        if (that.scanQRCodes[i].LoadingQty > that.scanQRCodes[i].Qty) {
          that.scanQRCodes[i].LoadingQty = that.scanQRCodes[i].Qty
        }
      }
      const feed = []
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        let haveFlag = false
        for (let j = 0; j < feed.length; j++) {
          if (feed[j].ItemID === that.scanQRCodes[i].ItemID && feed[j].BatchNo === that.scanQRCodes[i].BatchNo &&
            feed[j].KFPeriod === that.scanQRCodes[i].KFPeriod && feed[j].KFDate === that.scanQRCodes[i].KFDate &&
            feed[j].MTONo === that.scanQRCodes[i].MTONo) {
            feed[j].Qty += that.scanQRCodes[i].LoadingQty
            haveFlag = true
            break
          }
        }
        if (!haveFlag) {
          feed.push({
            ItemID: that.scanQRCodes[i].ItemID,
            ItemNumber: that.scanQRCodes[i].BI_Number,
            ItemName: that.scanQRCodes[i].BI_Name,
            ItemModel: that.scanQRCodes[i].BI_Model,
            UnitName: that.scanQRCodes[i].BU_Name,
            BatchNo: that.scanQRCodes[i].BatchNo,
            KFPeriod: that.scanQRCodes[i].KFPeriod,
            KFDate: that.scanQRCodes[i].KFDate,
            MTONo: that.scanQRCodes[i].MTONo,
            Qty: that.scanQRCodes[i].LoadingQty,
            UnitID: that.scanQRCodes[i].UnitID
          })
        }
      }
      that.icmoEntryLoadingInfo.Feed = feed
    },

    // 上料
    icmoEntryLoading: async function () {
      const that = this
      if (!that.icmoEntryLoadingInfo.EmployeeID && !that.icmoEntryLoadingInfo.EmployeeID2 &&
        !that.icmoEntryLoadingInfo.EmployeeID3 && !that.icmoEntryLoadingInfo.EmployeeID4 &&
        !that.icmoEntryLoadingInfo.EmployeeID5 && !that.icmoEntryLoadingInfo.EmployeeID6) {
        that.$message.error('请选择实际职员！')
        return
      }
      if (!that.icmoEntryLoadingInfo.MachineID) {
        that.$message.error('请选择实际设备！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码！')
        return
      }
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].LoadingQty = parseFloat(that.scanQRCodes[i].LoadingQty)
        } catch {
          that.scanQRCodes[i].LoadingQty = 0
        }
        if (isNaN(that.scanQRCodes[i].LoadingQty)) {
          that.scanQRCodes[i].LoadingQty = 0
        }
        if (that.scanQRCodes[i].LoadingQty <= 0) {
          that.$message.error('标签上料数量必须大于0！')
          return
        }
        if (that.scanQRCodes[i].LoadingQty > that.scanQRCodes[i].Qty) {
          that.$message.error('标签上料数量不得超过标签数量！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.LoadingICMOEntry', {
        icmoEntryLoadingInfo: that.icmoEntryLoadingInfo,
        scanQRCodes: that.scanQRCodes
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryLoadingDialog = false
        that.$message.success('上料成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤料弹出框显示方法
    showICMOEntryDownDialogMD: async function (scope) {
      const that = this
      that.icmoEntryDownInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryDownInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryDownInfo.InterID = scope.data.row.InterID
      that.icmoEntryDownInfo.Feed = []
      that.icmoEntryDownInfo.Remark = ''
      that.icmoEntryDownInfo.Qty = scope.data.row.Qty
      that.scanQRCodes = []
      that.showICMOEntryDownDialog = true
    },

    // 撤料扫码方法
    downScanQRCodeEnterMD: async function () {
      const that = this
      if (!that.icmoEntryDownInfo.DetailNo) {
        that.$message.error('请先选择工单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      qrCodeObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.GetDownQRCode', {
        qrCode: that.scanQRCode,
        detailNo: that.icmoEntryDownInfo.DetailNo
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号未在该工单上料，无法撤料！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          let haveScanFlag = false
          for (let j = 0; j < that.scanQRCodes.length; j++) {
            if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
              haveScanFlag = true
            }
          }
          if (haveScanFlag) {
            qrCodeObj.tableContent[i].haveScanFlag = true
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            continue
          }
          that.scanQRCodes.push(Object.assign(qrCodeObj.tableContent[i], {
            LoadingQty: qrCodeObj.tableContent[i].DownQty
          }))
        }
        that.scanQRCode = ''
        that.downScanQtyComputer()
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 撤料删除已扫描
    downDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      that.downScanQtyComputer()
    },

    // 撤料已扫数量计算
    downScanQtyComputer: function () {
      const that = this
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].DownQty = parseFloat(that.scanQRCodes[i].DownQty)
        } catch {
          that.scanQRCodes[i].DownQty = 0
        }
        if (isNaN(that.scanQRCodes[i].DownQty)) {
          that.scanQRCodes[i].DownQty = 0
        }
        if (that.scanQRCodes[i].DownQty <= 0) {
          that.scanQRCodes[i].DownQty = 0
        }
        if (that.scanQRCodes[i].DownQty > that.scanQRCodes[i].LoadingQty) {
          that.scanQRCodes[i].DownQty = that.scanQRCodes[i].LoadingQty
        }
      }
      const feed = []
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        let haveFlag = false
        for (let j = 0; j < feed.length; j++) {
          if (feed[j].ItemID === that.scanQRCodes[i].ItemID && feed[j].BatchNo === that.scanQRCodes[i].BatchNo &&
            feed[j].KFPeriod === that.scanQRCodes[i].KFPeriod && feed[j].KFDate === that.scanQRCodes[i].KFDate &&
            feed[j].MTONo === that.scanQRCodes[i].MTONo) {
            feed[j].Qty += that.scanQRCodes[i].DownQty
            haveFlag = true
            break
          }
        }
        if (!haveFlag) {
          feed.push({
            ItemID: that.scanQRCodes[i].ItemID,
            ItemNumber: that.scanQRCodes[i].BI_Number,
            ItemName: that.scanQRCodes[i].BI_Name,
            ItemModel: that.scanQRCodes[i].BI_Model,
            UnitName: that.scanQRCodes[i].BU_Name,
            BatchNo: that.scanQRCodes[i].BatchNo,
            KFPeriod: that.scanQRCodes[i].KFPeriod,
            KFDate: that.scanQRCodes[i].KFDate,
            MTONo: that.scanQRCodes[i].MTONo,
            Qty: that.scanQRCodes[i].DownQty,
            UnitID: that.scanQRCodes[i].UnitID
          })
        }
      }
      that.icmoEntryDownInfo.Feed = feed
    },

    // 撤料
    icmoEntryDown: async function () {
      const that = this
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码！')
        return
      }
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].DownQty = parseFloat(that.scanQRCodes[i].DownQty)
        } catch {
          that.scanQRCodes[i].DownQty = 0
        }
        if (isNaN(that.scanQRCodes[i].DownQty)) {
          that.scanQRCodes[i].DownQty = 0
        }
        if (that.scanQRCodes[i].DownQty <= 0) {
          that.$message.error('标签撤料数量必须大于0！')
          return
        }
        if (that.scanQRCodes[i].DownQty > that.scanQRCodes[i].LoadingQty) {
          that.$message.error('标签撤料数量不得超过已上料数量！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.DownICMOEntry', {
        icmoEntryDownInfo: that.icmoEntryDownInfo,
        scanQRCodes: that.scanQRCodes
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryDownDialog = false
        that.$message.success('撤料成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 补料弹出框显示方法
    showICMOEntryAddLoadingDialogMD: async function (scope) {
      const that = this
      that.icmoEntryAddLoadingInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryAddLoadingInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryAddLoadingInfo.InterID = scope.data.row.InterID
      that.icmoEntryAddLoadingInfo.Feed = []
      that.icmoEntryAddLoadingInfo.Remark = ''
      that.icmoEntryAddLoadingInfo.Qty = scope.data.row.Qty
      that.scanQRCodes = []
      that.showICMOEntryAddLoadingDialog = true
    },

    // 补料扫码方法
    addLoadingScanQRCodeEnterMD: async function () {
      const that = this
      if (!that.icmoEntryAddLoadingInfo.DetailNo) {
        that.$message.error('请先选择工单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        let passNum = 0
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryAddLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryAddLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            continue
          } else {
            passNum++
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryAddLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryAddLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            if (passNum === 0) {
              loadingInstance.close()
              that.$message.error('该标签号不是该生产任务单领出的，无法补料！')
              that.scanQRCode = ''
              return
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (that.icmoEntryAddLoadingInfo.InterID !== qrCodeObj.tableContent[i].OutSourceInterID ||
            that.icmoEntryAddLoadingInfo.BillNo !== qrCodeObj.tableContent[i].OutSourceBillNo) {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          that.scanQRCodes.push(Object.assign(qrCodeObj.tableContent[i], { AddLoadingQty: qrCodeObj.tableContent[i].Qty }))
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有可以补料的内箱标签！')
          return
        }
        that.addLoadingScanQtyComputer()
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 补料删除已扫描
    addLoadingDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      that.addLoadingScanQtyComputer()
    },

    // 补料已扫数量计算
    addLoadingScanQtyComputer: function () {
      const that = this
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].AddLoadingQty = parseFloat(that.scanQRCodes[i].AddLoadingQty)
        } catch {
          that.scanQRCodes[i].AddLoadingQty = 0
        }
        if (isNaN(that.scanQRCodes[i].AddLoadingQty)) {
          that.scanQRCodes[i].AddLoadingQty = 0
        }
        if (that.scanQRCodes[i].AddLoadingQty <= 0) {
          that.scanQRCodes[i].AddLoadingQty = 0
        }
        if (that.scanQRCodes[i].AddLoadingQty > that.scanQRCodes[i].Qty) {
          that.scanQRCodes[i].AddLoadingQty = that.scanQRCodes[i].Qty
        }
      }
      const feed = []
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        let haveFlag = false
        for (let j = 0; j < feed.length; j++) {
          if (feed[j].ItemID === that.scanQRCodes[i].ItemID && feed[j].BatchNo === that.scanQRCodes[i].BatchNo &&
            feed[j].KFPeriod === that.scanQRCodes[i].KFPeriod && feed[j].KFDate === that.scanQRCodes[i].KFDate &&
            feed[j].MTONo === that.scanQRCodes[i].MTONo) {
            feed[j].Qty += that.scanQRCodes[i].AddLoadingQty
            haveFlag = true
            break
          }
        }
        if (!haveFlag) {
          feed.push({
            ItemID: that.scanQRCodes[i].ItemID,
            ItemNumber: that.scanQRCodes[i].BI_Number,
            ItemName: that.scanQRCodes[i].BI_Name,
            ItemModel: that.scanQRCodes[i].BI_Model,
            UnitName: that.scanQRCodes[i].BU_Name,
            BatchNo: that.scanQRCodes[i].BatchNo,
            KFPeriod: that.scanQRCodes[i].KFPeriod,
            KFDate: that.scanQRCodes[i].KFDate,
            MTONo: that.scanQRCodes[i].MTONo,
            Qty: that.scanQRCodes[i].AddLoadingQty,
            UnitID: that.scanQRCodes[i].UnitID
          })
        }
      }
      that.icmoEntryAddLoadingInfo.Feed = feed
    },

    // 补料
    icmoEntryAddLoading: async function () {
      const that = this
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码！')
        return
      }
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        try {
          that.scanQRCodes[i].AddLoadingQty = parseFloat(that.scanQRCodes[i].AddLoadingQty)
        } catch {
          that.scanQRCodes[i].AddLoadingQty = 0
        }
        if (isNaN(that.scanQRCodes[i].AddLoadingQty)) {
          that.scanQRCodes[i].AddLoadingQty = 0
        }
        if (that.scanQRCodes[i].AddLoadingQty <= 0) {
          that.$message.error('标签补料数量必须大于0！')
          return
        }
        if (that.scanQRCodes[i].AddLoadingQty > that.scanQRCodes[i].Qty) {
          that.$message.error('标签补料数量不得超过标签数量！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.AddLoadingICMOEntry', {
        icmoEntryAddLoadingInfo: that.icmoEntryAddLoadingInfo,
        scanQRCodes: that.scanQRCodes
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryAddLoadingDialog = false
        that.$message.success('补料成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 开工弹出框显示方法
    showICMOEntryStartDialogMD: function (scope) {
      const that = this
      that.icmoEntryStartInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryStartInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryStartInfo.InterID = scope.data.row.InterID
      that.icmoEntryStartInfo.Remark = ''
      that.icmoEntryStartInfo.Qty = scope.data.row.Qty
      that.icmoEntryStartInfo.EmployeeID = scope.data.row.EmployeeID
      that.icmoEntryStartInfo.EmployeeID2 = scope.data.row.EmployeeID2
      that.icmoEntryStartInfo.EmployeeID3 = scope.data.row.EmployeeID3
      that.icmoEntryStartInfo.EmployeeID4 = scope.data.row.EmployeeID4
      that.icmoEntryStartInfo.EmployeeID5 = scope.data.row.EmployeeID5
      that.icmoEntryStartInfo.EmployeeID6 = scope.data.row.EmployeeID6
      that.icmoEntryStartInfo.MachineID = scope.data.row.MachineID
      that.showICMOEntryStartDialog = true
    },

    // 开工
    icmoEntryStart: async function () {
      const that = this
      if (!that.icmoEntryStartInfo.EmployeeID && !that.icmoEntryStartInfo.EmployeeID2 &&
        !that.icmoEntryStartInfo.EmployeeID3 && !that.icmoEntryStartInfo.EmployeeID4 &&
        !that.icmoEntryStartInfo.EmployeeID5 && !that.icmoEntryStartInfo.EmployeeID6) {
        that.$message.error('请选择实际职员！')
        return
      }
      if (!that.icmoEntryStartInfo.MachineID) {
        that.$message.error('请选择实际设备！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.StartICMOEntry', {
        icmoEntryStartInfo: that.icmoEntryStartInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryStartDialog = false
        that.$message.success('开工成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤销开工
    cancelICMOEntryStart: function (scope) {
      const that = this
      that.$confirm('确定要撤销开工该工单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelStartICMOEntry', {
          detailNo: scope.data.row.DetailNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('撤销成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 暂停弹出框显示方法
    showICMOEntryStopDialogMD: function (scope) {
      const that = this
      that.icmoEntryStopInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryStopInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryStopInfo.InterID = scope.data.row.InterID
      that.icmoEntryStopInfo.Remark = ''
      that.icmoEntryStopInfo.Qty = scope.data.row.Qty
      that.icmoEntryStopInfo.EmployeeID = scope.data.row.EmployeeID
      that.icmoEntryStopInfo.EmployeeID2 = scope.data.row.EmployeeID2
      that.icmoEntryStopInfo.EmployeeID3 = scope.data.row.EmployeeID3
      that.icmoEntryStopInfo.EmployeeID4 = scope.data.row.EmployeeID4
      that.icmoEntryStopInfo.EmployeeID5 = scope.data.row.EmployeeID5
      that.icmoEntryStopInfo.EmployeeID6 = scope.data.row.EmployeeID6
      that.icmoEntryStopInfo.MachineID = scope.data.row.MachineID
      that.showICMOEntryStopDialog = true
    },

    // 暂停
    icmoEntryStop: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.StopICMOEntry', {
        icmoEntryStopInfo: that.icmoEntryStopInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryStopDialog = false
        that.$message.success('暂停成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 继续弹出框显示方法
    showICMOEntryContinueDialogMD: function (scope) {
      const that = this
      that.icmoEntryContinueInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryContinueInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryContinueInfo.InterID = scope.data.row.InterID
      that.icmoEntryContinueInfo.Remark = ''
      that.icmoEntryContinueInfo.Qty = scope.data.row.Qty
      that.icmoEntryContinueInfo.EmployeeID = scope.data.row.EmployeeID
      that.icmoEntryContinueInfo.EmployeeID2 = scope.data.row.EmployeeID2
      that.icmoEntryContinueInfo.EmployeeID3 = scope.data.row.EmployeeID3
      that.icmoEntryContinueInfo.EmployeeID4 = scope.data.row.EmployeeID4
      that.icmoEntryContinueInfo.EmployeeID5 = scope.data.row.EmployeeID5
      that.icmoEntryContinueInfo.EmployeeID6 = scope.data.row.EmployeeID6
      that.icmoEntryContinueInfo.MachineID = scope.data.row.MachineID
      that.showICMOEntryContinueDialog = true
    },

    // 继续
    icmoEntryContinue: async function () {
      const that = this
      if (!that.icmoEntryContinueInfo.EmployeeID && !that.icmoEntryContinueInfo.EmployeeID2 &&
        !that.icmoEntryContinueInfo.EmployeeID3 && !that.icmoEntryContinueInfo.EmployeeID4 &&
        !that.icmoEntryContinueInfo.EmployeeID5 && !that.icmoEntryContinueInfo.EmployeeID6) {
        that.$message.error('请选择实际职员！')
        return
      }
      if (!that.icmoEntryContinueInfo.MachineID) {
        that.$message.error('请选择实际设备！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.ContinueICMOEntry', {
        icmoEntryContinueInfo: that.icmoEntryContinueInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryContinueDialog = false
        that.$message.success('继续成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 完工弹出框显示方法
    showICMOEntryEndDialogMD: function (scope) {
      const that = this
      that.icmoEntryEndInfo.DetailNo = scope.data.row.DetailNo
      that.icmoEntryEndInfo.BillNo = scope.data.row.BillNo
      that.icmoEntryEndInfo.InterID = scope.data.row.InterID
      that.icmoEntryEndInfo.Remark = ''
      that.icmoEntryEndInfo.Qty = scope.data.row.Qty
      that.icmoEntryEndInfo.EmployeeID = scope.data.row.EmployeeID
      that.icmoEntryEndInfo.EmployeeID2 = scope.data.row.EmployeeID2
      that.icmoEntryEndInfo.EmployeeID3 = scope.data.row.EmployeeID3
      that.icmoEntryEndInfo.EmployeeID4 = scope.data.row.EmployeeID4
      that.icmoEntryEndInfo.EmployeeID5 = scope.data.row.EmployeeID5
      that.icmoEntryEndInfo.EmployeeID6 = scope.data.row.EmployeeID6
      that.icmoEntryEndInfo.MachineID = scope.data.row.MachineID
      that.showICMOEntryEndDialog = true
    },

    // 完工
    icmoEntryEnd: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.EndICMOEntry', {
        icmoEntryEndInfo: that.icmoEntryEndInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showICMOEntryEndDialog = false
        that.$message.success('完工成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤销完工
    cancelICMOEntryEnd: function (scope) {
      const that = this
      that.$confirm('确定要撤销完工该工单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelEndICMOEntry', {
          detailNo: scope.data.row.DetailNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('撤销成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 已上材料查询弹出框显示方法
    showICMOEntryFeedDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const icmoEntryFeedsObj = await table.getTableContent('PM_ICMOEntryFeed'
        , 10000, 1, ' ItemNumber ASC', " AND DetailNo='" + scope.data.row.DetailNo + "'")
      if (icmoEntryFeedsObj.error === '000000') {
        that.icmoEntryFeeds = icmoEntryFeedsObj.tableContent
        that.showICMOEntryFeedsRow = scope.data.row
        that.showICMOEntryFeedDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
</style>
